import Grid from '@material-ui/core/Grid';
import React from 'react';
import { useTranslate } from 'react-admin';
import BackDiv from '../../commons/BackDiv/BackDiv';
import Breadcrumbs from '../../commons/Breadcrumbs/Breadcrumbs';
import SubCategoryList from './list/index';
import './styles.css';

const SubCategory = () => {
    const translate = useTranslate();

    return (
        <Grid container direction='column'>
            <Grid item>
                <Breadcrumbs
                    items={[translate('app.subCategory.breadcrumbs.1')]}
                    lastItem={translate('app.subCategory.breadcrumbs.0')}
                />
            </Grid>

            <Grid item>
                <BackDiv>
                    {({ divHeight }: { divHeight: number }) => (
                        <div className='subCategoryTable' style={{ height: divHeight }}>
                            <SubCategoryList divHeight={divHeight} />
                        </div>
                    )}
                </BackDiv>
            </Grid>
        </Grid>
    );
};

export default SubCategory;
